// Shared loader for /api/ski_areas. Two callers (Header for search, ResortTerrain3D
// for nearby-resorts overlay) both mount on the resort detail page, and before
// this module each fired its own request. That cost ~2.5–3s twice on every
// resort page. Now: sessionStorage cache + module-level inflight promise dedupes
// concurrent calls in the same page load.

const CACHE_KEY = 'pm-ski-areas';
let inflight = null;

export function loadSkiAreas() {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) return Promise.resolve(JSON.parse(cached));
  } catch { /* quota / private mode */ }

  if (inflight) return inflight;

  inflight = fetch('/api/ski_areas')
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      if (data) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch { /* quota */ }
      }
      return data;
    })
    .catch(() => null)
    .finally(() => { inflight = null; });

  return inflight;
}
